module.exports = {"data":{"site":{"siteMetadata":{"title":"Apheleia Press"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 137
// module chunks = 22676092666560 60335399758886